"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StyledTag = require("./StyledTag");
var _CheckableTag = _interopRequireDefault(require("./CheckableTag"));
var _excluded = ["prefixCls", "className", "style", "children", "icon", "color", "size", "closable", "onClose", "noBorder"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var InternalTag = function InternalTag(_ref, ref) {
  var prefixCls = _ref.prefixCls,
    className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    icon = _ref.icon,
    color = _ref.color,
    size = _ref.size,
    closable = _ref.closable,
    onClose = _ref.onClose,
    noBorder = _ref.noBorder,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  (0, _react.useEffect)(function () {
    if ('visible' in props) {
      setVisible(props.visible);
    }
  }, [props.visible]);
  var tagStyle = _objectSpread({}, style);
  var handleCloseClick = function handleCloseClick(e) {
    e.stopPropagation();
    onClose === null || onClose === void 0 ? void 0 : onClose(e);
    if (e.defaultPrevented) {
      return;
    }
    if (!('visible' in props)) {
      setVisible(false);
    }
  };
  var renderCloseIcon = function renderCloseIcon(_prefixCls, theme) {
    if (closable) {
      return /*#__PURE__*/_react.default.createElement(_StyledTag.StyledCloseIcon, {
        className: "".concat(_prefixCls, "-close-icon"),
        name: "close",
        $theme: theme,
        prefixCls: _prefixCls,
        onClick: handleCloseClick
      });
    }
    return null;
  };
  var kids = icon ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, icon, /*#__PURE__*/_react.default.createElement("span", null, children)) : children;
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react.default.createElement(_StyledTag.StyledTag, (0, _extends2.default)({
      theme: theme,
      size: size,
      prefixCls: prefixCls
    }, props, {
      ref: ref,
      extraCls: className,
      visible: visible,
      style: tagStyle,
      color: color,
      icon: icon,
      closable: closable,
      noBorder: noBorder
    }), function (styledPrefix) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, kids, renderCloseIcon(styledPrefix, theme));
    });
  });
};
var Tag = /*#__PURE__*/(0, _react.forwardRef)(InternalTag);
Tag.propTypes = {
  prefixCls: _propTypes.default.string,
  className: _propTypes.default.string,
  color: _propTypes.default.string,
  closable: _propTypes.default.bool,
  closeIcon: _propTypes.default.node,
  visible: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  style: _propTypes.default.object,
  icon: _propTypes.default.node,
  size: _propTypes.default.oneOf(['default', 'large', 'small']),
  noBorder: _propTypes.default.bool
};
Tag.defaultProps = {
  closable: false,
  size: 'default'
};
Tag.displayName = 'Tag';
var WrappedTag = (0, _inputHOC.default)(Tag);
WrappedTag.CheckableTag = _CheckableTag.default;
var _default = exports.default = WrappedTag;